import Vue from 'vue'
import ProgressBouncing from "@fixit/progress-bouncing";

Vue.component('progress-bouncing', ProgressBouncing)
